# NewsSources.vue
<template>
  <div class="news-sources">
    <form @submit.prevent="emitSave">
      <div class="content-container">
        <!-- Publications Column -->
        <div class="settings-column">
          <h2 class="section-title">Publications</h2>
          
          <!-- Town Settings Section -->
          <div class="publication-section">
            <h3 class="subsection-title">Ansable Town Coverage</h3>
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.townSettings.selectBoard"
                />
                <span>Select Board</span>
              </label>
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.townSettings.schoolBoard"
                />
                <span>School Board</span>
              </label>
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.townSettings.otherTownMeetings"
                />
                <span>Town Meeting</span>
              </label>
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.townSettings.commissionGroup"
                />
                <span>Commission/Sub-Group</span>
              </label>
              <!-- New checkboxes added below -->
              <label class="checkbox-label">
                <input type="checkbox" v-model="localData.townSettings.upcomingMeetings" />
                <span>Upcoming Meetings</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="localData.townSettings.minutesOnly" />
                <span>Minute Only Meetings</span>
              </label>
            </div>
          </div>
          
          <!-- Vermont State Publications -->
          <div class="publication-section">
            <h3 class="subsection-title">Vermont State Publications</h3>
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.publications.vtDigger"
                />
                <span>VT Digger</span>
              </label>
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.publications.sevenDays"
                />
                <span>Seven Days</span>
              </label>
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.publications.vtPublic"
                />
                <span>Vermont Public</span>
              </label>
            </div>
          </div>

          <!-- Addison County Publications -->
          <div v-if="county === 'Addison'" class="publication-section">
            <h3 class="subsection-title">Addison County</h3>
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.publications.addisonIndependent"
                />
                <span>Addison Independent</span>
              </label>
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="localData.publications.brandonReporter"
                />
                <span>Brandon Reporter</span>
              </label>
            </div>
          </div>

          <!-- Rutland County Publications -->
          <div v-if="county === 'Rutland'" class="publication-section">
            <h3 class="subsection-title">Rutland County</h3>
            
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="actions">
        <button 
          type="submit" 
          class="save-button"
          :disabled="saving"
        >
          {{ saving ? 'Saving...' : 'Save Information' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/firebase";

export default {
  name: 'NewsSources',
  props: {
    userInfo: Object,
    saving: Boolean
  },
  data() {
    return {
      localData: JSON.parse(JSON.stringify(this.userInfo)),
      county: null,
    };
  },
  mounted() {
    this.fetchCounty();
  },
  methods: {
    fetchCounty() {
      if (this.localData.address && this.localData.address.city) {
        const town = this.localData.address.city.trim();
        const townDocRef = doc(db, "townMapping", town);
        getDoc(townDocRef)
          .then(docSnap => {
            if (docSnap.exists()) {
              this.county = docSnap.data().county;
            }
          })
          .catch(err => {
            console.error("Error fetching town mapping:", err);
          });
      }
    },
    emitSave() {
      this.$emit('updateUserInfo', this.localData);
      this.$emit('saveUserInfo');
    }
  },
  watch: {
    userInfo(newVal) {
      this.localData = JSON.parse(JSON.stringify(newVal));
    }
  }
};
</script>

<style scoped>
.news-sources {
  padding: 24px;
  max-width: 800px;
}

.content-container {
  margin-bottom: 32px;
}

.settings-column {
  max-width: 600px;
}

.section-title {
  font-size: 32px;
  font-weight: 600;
  color: #545051;
  margin-bottom: 24px;
  text-align: left;
}

@media (max-width: 768px) {
  .section-title {
    display: none;
  }
}

.subsection-title {
  font-size: 1rem;
  font-weight: 600;
  color: #545051;
  margin-bottom: 16px;
  text-align: left;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #545051;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.publication-section {
  margin-bottom: 24px;
}

.publication-section:last-child {
  margin-bottom: 0;
}

.actions {
  display: flex;
  justify-content: flex-start;
}

.save-button {
  background-color: #545051;
  color: white;
  border: none;
  padding: 8px 24px;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.save-button:hover {
  background-color: #636063;
}

.save-button:disabled {
  background-color: #a8a8a8;
  cursor: not-allowed;
}
</style>